<template>
  <footer v-if="footer" class="CorporateFooter bg-bg-subtle">
    <FooterMenu />
    <div class="layout-container desk:border-t desk:border-light desk:min-h-0 pt-16 pb-32 flex flex-col justify-between">
      <div class="mobOnly:px-0 flex flex-col desk:flex-row flex-wrap justify-between items-center gap-24">
        <div class="text-center pt-16 desk:pt-0 type-sm leading-single text-darkest">
          <div class="flex flex-col desk:flex-row flex-wrap items-center gap-16">
            <div class="order-2 desk:order-1 whitespace-nowrap">
              {{ footer.copyright.replace('##YEAR##', new Date().getFullYear()) }}
            </div>
            <ul v-if="footerMeta.length" class="MetaLinks flex flex-wrap mobOnly:items-center mobOnly:justify-center gap-8 desk:gap-12 order-3">
              <li v-for="footerMetaItem in footerMeta" :key="footerMetaItem._uid">
                <nuxt-link
                  :to="$sbLinkFix(footerMetaItem.link)"
                  :target="$sbLinkTarget(footerMetaItem.link)"
                  class="hover:underline underline-offset-4 decoration-1"
                >
                  {{ footerMetaItem.title }}
                </nuxt-link>
              </li>
            </ul>

            <div class="order-3 mobOnly:order-1">
              <CorpLangSelector :footer-styling="true"/>
            </div>

          </div>
        </div>
        <div>
          <div v-if="footer.footerLogos" class="flex flex-row flex-wrap justify-center gap-8">
            <div v-for="(image, index) in footer.footerLogos" :key="index">
              <nuxt-img
                preset="standard"
                loading="lazy"
                sizes="24px"
                class="h-24 w-auto object-cover"
                :src="image.filename"
                :alt="image.alt || 'Logo'"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  </footer>
</template>

<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';
import FooterMenu from '~/components/body/FooterMenu.vue';
import CorpLangSelector from '~/components/menu/CorpLangSelector.vue';

const globalContent = useGlobalContentStore();

const footer = globalContent.getFooter;
const footerMeta = globalContent.getFooterMetaLinks;
</script>
